import { LeagueConfig, Environment } from '@leagueplatform/core';
import { archetypeLightTheme } from '@leagueplatform/genesis-core';
import { createReactRouterAdapter } from '@leagueplatform/react-router-adapter';
import { StandaloneAuth } from '@leagueplatform/auth-standalone';
import { APP_ID } from 'common/constants';
import { LoadingSpinner } from 'components/loading-spinner/loading-spinner.component';

import CareDocumentIcon from './assets/care-document-icon.svg';
import CareDocumentErrorSubtleIcon from './assets/error-subtle-icon.svg';

const {
  VITE_SEGMENT_KEY,
  VITE_WS_API_URL,
  VITE_API_URL,
  VITE_LEGACY_REST_API_URL,
  VITE_CONTENT_URL,
  VITE_AUTH0_DOMAIN,
  VITE_AUTH0_CLIENT_ID,
  VITE_APP_ENV,
  VITE_APP_CLIENT_ID,
  VITE_AUTH0_AUDIENCE,
} = import.meta.env;

const authConfig = {
  domain: VITE_AUTH0_DOMAIN!,
  client_id: VITE_AUTH0_CLIENT_ID!,
  redirect_uri: window.location.origin,
  audience: VITE_AUTH0_AUDIENCE!,
};

const analyticsConfig = {
  segmentKey: VITE_SEGMENT_KEY,
};

const apiConfig = {
  wsUrl: VITE_WS_API_URL!,
  url: VITE_API_URL!,
  legacyRestApi: VITE_LEGACY_REST_API_URL!,
};

export const config: LeagueConfig = {
  core: {
    clientId: VITE_APP_CLIENT_ID || APP_ID,
    auth: {
      clientOptions: authConfig,
      idleSessionLifetimeHours: 0.25,
      sessionTimeoutOptions: {
        onSessionExpire: () =>
          StandaloneAuth.client.logout({
            returnTo: window.location.origin,
            federated: true,
          }),
      },
    }, // Default 15 minutes, should match the auth0 session inactivity timeout
    analytics: analyticsConfig,
    api: apiConfig,
    appEnvironment: VITE_APP_ENV as Environment,
    contentUrl: VITE_CONTENT_URL!,
    routing: { adapter: createReactRouterAdapter() },
    ui: {
      theme: archetypeLightTheme, // overriden in app.tsx based on context
      components: {
        pageHeader: {
          shape: 'line',
          backgroundColor: 'interactive.background.hovered',
        },
        loading: {
          element: <LoadingSpinner />,
          text: false,
        },
      },
    },
  },
  assets: {
    overrides: {
      CARE_DOCUMENT_ICON: CareDocumentIcon,
      ERROR_STATE_ICON: CareDocumentErrorSubtleIcon,
    },
  },
  healthJourney: {
    tabs: ['activities'],
    headerConfig: {
      disableBackgroundImage: true,
      backgroundColor: '$surfaceBackgroundTertiary',
    },
    activityDetailsConfig: {
      enableFullPageBackground: true,
    },
  },
  __internal: {
    shouldApplyCSSReset: true,
    shouldApplyLegacyGlobalStyles: true,
    shouldIgnoreDOMLangAttributeForLocale: true,
  },
};
